<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'StyledDialogHeader',
  mixins: [baseMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    compTitleClass() {
      return this.isMediumOrLower
        ? 'text-subtitle-1 font-weight-medium'
        : 'font-weight-medium'
    },
    hasDescription() {
      return !!this.description
    },
  },
}
</script>

<template>
  <div
    :class="[
      'styled-dialog-header__header pa-sm-4',
      hasDescription ? '' : 'overflow-hidden',
    ]"
    style="position: relative"
  >
    <v-toolbar flat dark class="transparent mb-0 styled-dialog-header__toolbar">
      <v-toolbar-title :title="title" :class="compTitleClass">
        <slot name="title">
          <span v-if="!loading">{{ title }}</span>
        </slot>
        <slot name="subtitle">
          <p v-if="subtitle" class="mb-0 text-subtitle-2 opacity-8">{{
            subtitle
          }}</p>
        </slot>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="d-flex align-center">
        <slot name="actions"> </slot>
        <v-btn
          :title="$t('general.close')"
          icon
          :small="isSmallOrLower"
          data-testid="styled-dialog-header-icon-close-btn"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-toolbar>

    <slot name="description">
      <p
        v-if="hasDescription"
        v-sanitized-html="description"
        data-testid="styled-dialog-header-description"
        class="mb-0 px-4 white--text styled-dialog-header__description"
      ></p>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/colors';

.styled-dialog-header__header {
  background: linear-gradient(
    0deg,
    $color-blue-400 100%,
    $color-blue-400,
    $color-blue-400 37%,
    $color-blue-400 0
  );
}

.styled-dialog-header__toolbar {
  z-index: 2; // To sit above the shapes and allow for toolbar actions to be clickable
}

.styled-dialog-header__description {
  position: relative; // Ensures z-index is applied
  z-index: 2; // To sit above the shapes and allow links to be clickable and text to be highlighted
}

.styled-dialog-header__description::v-deep a {
  color: $color-white; // Overwrites link color so it doesn't blend into panel header
}
</style>
